const germanDecimalFormatterWithoutFractions = new Intl.NumberFormat('de-DE', {
  style: 'decimal',
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
});

export const formatNumber = (val: number): string =>
  germanDecimalFormatterWithoutFractions.format(val);

export const formatPercent = (val: number): string => `${val} %`;

export const formatSquareMeter = (val: number): string => `${val} m²`;

export const number = (val: number | string): number => Number(val);
